const CartActionTypes = {
    TOGGLE_CART_HIDDEN: "TOGGLE_CART_HIDDEN",
    ADD_CART_ITEM: "ADD_CART_ITEM",
    REMOVE_CART_ITEM: "REMOVE_CART_ITEM",
    CART_ITEM_ADD_QUANTITY: "CART_ITEM_ADD_QUANTITY",
    CART_ITEM_REMOVE_QUANTITY: "CART_ITEM_REMOVE_QUANTITY",
  };
  
  export default CartActionTypes;
  